import { FilterTypes } from 'app/components/filters/types';
import { FilterMenuOptions } from 'app/components/filters/types';

interface FilterMenuOptionsConfiguration {
  [option: number]: FilterMenuOptions[];
}

export const createFilterMenuOptions = (advancedSearchType: FilterTypes) => {
  const allDefaultOptions: FilterMenuOptions[] = [
    FilterMenuOptions.Clear,
    FilterMenuOptions.Include,
    FilterMenuOptions.Exclude
  ];

  const allSubLevelOptions: FilterMenuOptions[] = [
    FilterMenuOptions.IncludeSubLevels,
    FilterMenuOptions.ExcludeSubLevels
  ];

  const configuration: FilterMenuOptionsConfiguration = {
    [FilterTypes.SelectMultiple]: allDefaultOptions,
    [FilterTypes.SelectMultipleFlat]: allDefaultOptions,
    [FilterTypes.SelectMultipleHierarchy]: allDefaultOptions.concat(allSubLevelOptions),
    [FilterTypes.SelectMultipleFlatWithCategories]: allDefaultOptions,
    [FilterTypes.SelectMultipleFlatSequentialWithCategories]: allDefaultOptions,
    [FilterTypes.SelectMultipleHierarchyWithCategories]: allDefaultOptions.concat(allSubLevelOptions),
    [FilterTypes.SelectMultipleHierarchySequentialWithCategories]: allDefaultOptions.concat(allSubLevelOptions),
    [FilterTypes.TextField]: allDefaultOptions,
    [FilterTypes.DateField]: allDefaultOptions,
    [FilterTypes.NumberField]: allDefaultOptions,
    [FilterTypes.DecimalNumber]: allDefaultOptions,
    [FilterTypes.CheckBox]: allDefaultOptions,
    [FilterTypes.PredefDate]: [FilterMenuOptions.Clear],
    [FilterTypes.PredefFilters]: [
      FilterMenuOptions.Clear
    ],
    [FilterTypes.MyUnit]: allDefaultOptions.concat(allSubLevelOptions),
    [FilterTypes.MyLocation]: allDefaultOptions.concat(allSubLevelOptions),
    [FilterTypes.Person]: allDefaultOptions
  };

  return configuration[advancedSearchType];
};
